function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Raggruppa_3755",
  "data-name": "Raggruppa 3755",
  transform: "translate(2060.646 -1159.902)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Tracciato_350",
  d: "M9.126.02C4.821.02.47,2.429.47,7.826v4.915a1.189,1.189,0,0,0,1.182,1.182A1.183,1.183,0,0,0,2.8,12.741V7.826c0-3.59,3.184-5.472,6.33-5.472a1.179,1.179,0,0,0,1.182-1.182A1.153,1.153,0,0,0,9.156.02h-.03",
  transform: "translate(-2061.116 1159.898)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Tracciato_351",
  d: "M71.092.02A1.184,1.184,0,0,0,69.91,1.2V6.117c0,5.389,4.351,7.806,8.656,7.806a1.154,1.154,0,0,0,1.182-1.129v-.023a1.189,1.189,0,0,0-1.182-1.182c-3.146,0-6.33-1.882-6.33-5.472V1.2A1.176,1.176,0,0,0,71.092.02",
  transform: "translate(-2078.287 1159.898)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Tracciato_352",
  d: "M27.852,5.525A6.726,6.726,0,0,0,21.093,0,7.433,7.433,0,0,0,19.617.15a6.946,6.946,0,0,0,2.86,13.594l.068-.015A6.724,6.724,0,0,0,26.422,11.7a1.259,1.259,0,0,0,.263-1.664,1.276,1.276,0,0,0-.979-.482.845.845,0,0,0-.625.248A5.893,5.893,0,0,1,22,11.456,4.605,4.605,0,0,1,17.081,9.3l-.188-.309.354-.075,9.7-2.04a1.131,1.131,0,0,0,.918-1.325.028.028,0,0,0-.008-.023m-2.966-.58L16.765,6.654l-.354.075.045-.361A4.661,4.661,0,0,1,20.1,2.431a4.964,4.964,0,0,1,1.054-.113,4.294,4.294,0,0,1,3.9,2.243l.166.3Z",
  transform: "translate(-2064.486 1159.904)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Tracciato_353",
  d: "M135.372,5.527A6.713,6.713,0,0,0,128.613.009a7.49,7.49,0,0,0-1.475.151A6.946,6.946,0,1,0,130,13.754l.068-.015a6.724,6.724,0,0,0,3.877-2.032,1.259,1.259,0,0,0,.263-1.664,1.276,1.276,0,0,0-.979-.482.874.874,0,0,0-.632.248,5.893,5.893,0,0,1-3.079,1.656,4.605,4.605,0,0,1-4.923-2.16L124.405,9l.354-.075,9.7-2.04a1.154,1.154,0,0,0,.918-1.347V5.527M132.4,4.94l-8.122,1.709-.354.075.045-.361a4.67,4.67,0,0,1,3.643-3.937,4.964,4.964,0,0,1,1.054-.113,4.294,4.294,0,0,1,3.9,2.243l.166.3Z",
  transform: "translate(-2091.073 1159.901)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Tracciato_354",
  d: "M43.779.153A1.207,1.207,0,0,0,43.349.07a1.17,1.17,0,0,0-1.084.768L39.285,8.847l-.241.64-.241-.64L35.792.838A1.155,1.155,0,0,0,34.7.078a1.167,1.167,0,0,0-.422.083,1.088,1.088,0,0,0-.655.595,1.178,1.178,0,0,0-.03.918L37.9,13.16a1.2,1.2,0,0,0,1.107.783,1.224,1.224,0,0,0,1.137-.783L44.448,1.681a1.147,1.147,0,0,0-.03-.918,1.027,1.027,0,0,0-.64-.61",
  transform: "translate(-2069.287 1159.886)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Tracciato_355",
  d: "M55.938,0a6.948,6.948,0,1,0,6.948,6.948h0A6.955,6.955,0,0,0,55.938,0m0,11.569a4.622,4.622,0,1,1,4.622-4.622,4.623,4.623,0,0,1-4.622,4.622",
  transform: "translate(-2073.114 1159.903)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Tracciato_356",
  d: "M85.232.04A1.157,1.157,0,0,0,84.08,1.192V8.4a5.559,5.559,0,0,0,11.118.03V1.192A1.157,1.157,0,0,0,94.046.04a1.173,1.173,0,0,0-1.182,1.152V8.365a3.229,3.229,0,0,1-6.458,0V1.192A1.166,1.166,0,0,0,85.232.04",
  transform: "translate(-2081.791 1159.894)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Tracciato_357",
  d: "M114.654,3.5A7.028,7.028,0,0,0,108.618.04a6.948,6.948,0,1,0,5.841,10.711,1.173,1.173,0,0,0-.324-1.626h0a1.221,1.221,0,0,0-.625-.173,1.17,1.17,0,0,0-.994.527,4.569,4.569,0,0,1-3.892,2.123A4.687,4.687,0,0,1,104,6.98a4.623,4.623,0,0,1,8.626-2.311,1.2,1.2,0,0,0,1.024.565,1.188,1.188,0,0,0,.58-.151,1.17,1.17,0,0,0,.422-1.581",
  transform: "translate(-2086.14 1159.894)",
  fill: "#fff"
}));

function SvgLogoEstesoWh(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 104.966,
    height: 13.927,
    viewBox: "0 0 104.966 13.927",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoEstesoWh);
export default __webpack_public_path__ + "static/media/logo_esteso_wh.e08f8b84.svg";
export { ForwardRef as ReactComponent };